import {
  AttributesQuery,
  DataType,
  DefaultValueBehaviour,
  FieldsListQuery_category_fields as Field,
} from '../../../../types/api';
import { GroupT } from '../types';

export function mapInitialValues(
  fields: Field[] = [],
  contextData?: AttributesQuery,
): { [key: string]: string | boolean } {
  // Set initial values to default value
  const initialValues = fields.reduce((acc, { dataType, defaultValue, id }) => {
    if (dataType === DataType.BOOLEAN) {
      acc[id] = defaultValue === 'true';
    } else {
      acc[id] = defaultValue || '';
    }

    return acc;
  }, {});

  // If there are any attributes for this customer prefill them in the initialValues map
  if (
    contextData &&
    contextData.context &&
    contextData.context.attributes.length > 0
  ) {
    contextData.context.attributes.forEach(({ field, value }) => {
      // If defautlValue behaviour is fixed,
      // the field / category default value has precedence over context attributes.
      // In this case we do not want to override
      if (field.defaultValueBehaviour === DefaultValueBehaviour.FIXED) {
        return;
      }

      if (field.dataType === DataType.BOOLEAN) {
        initialValues[field.id] = value === 'true';
      } else {
        initialValues[field.id] = value;
      }
    });
  }

  return initialValues;
}

export function mapFieldDefinitions(
  fields: Field[] = [],
): Array<GroupT | Field> {
  const fieldDefinitions: {
    [key: string]: Field | GroupT;
  } = {};

  fields
    .filter((field) => field.visible)
    .forEach((field) => {
      // If a field does not have a fieldGroupId just add it like it is.
      if (!field.fieldGroup) {
        fieldDefinitions[field.key] = field;

        return;
      }
      // If a field does have a fieldGroupId but the fieldGroupId is not in the fieldDefinitions object yet
      // initialize the group with { type: 'GROUP', order: field.order, id: field.fieldGroupId }
      if (!fieldDefinitions[field.fieldGroup.id]) {
        fieldDefinitions[field.fieldGroup.id] = {
          ...field.fieldGroup,
          inputType: 'GROUP',
          section: field.section,
          order: field.order,
          fields: [],
        };
      }
      // Add the field to the correct group
      // We ignore this line as typescript cannot figure out the generic objects.
      // @ts-ignore
      fieldDefinitions[field.fieldGroup.id].fields.push(field);
    });

  const sortedFieldDefinitions = Object.values(fieldDefinitions)
    .map((field) => ({
      ...field,
      order: field.order ?? Number.MAX_SAFE_INTEGER,
    }))
    .sort(({ order: orderA }, { order: orderB }) => {
      if (orderA < orderB) {
        return -1;
      }
      if (orderA > orderB) {
        return 1;
      }

      return 0;
    });

  return sortedFieldDefinitions;
}
